import request from '@/src/apis/axios';
import {
  GetCommunityCommentByIdRequestParams,
  GetCommunityCommentsRequestParams,
} from '@/src/apis/rest/communityComment.dtos';
import CommunityCommentDto from '@/src/models/CommunityCommentDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';

const URL = {
  comunityComments: '/admin/community-comments',
  comunityCommentDetail: '/admin/community-comments/{id}',
  communityCommentExcel: '/admin/community-comments/excel/export',
};

// 커뮤니티 리스트 조회
export const getCommunityCommentsAPI = async (
  requestParams: Partial<GetCommunityCommentsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<CommunityCommentDto>>({
    method: 'get',
    url: URL.comunityComments,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(CommunityCommentDto, data.rows);

  return { rows, count: data.count };
};

// 커뮤니티 댓글 리스트 엑셀 다운로드
export const getCommunityCommentExcelAPI = async (
  password: string,
  requestParams: Partial<GetCommunityCommentsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.communityCommentExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};

// 커뮤니티 상세 조회
export const getCommunityCommentByIdAPI = async ({
  id,
}: Partial<GetCommunityCommentByIdRequestParams>) => {
  const { data } = await request<ObjectResponse<CommunityCommentDto>>({
    method: 'get',
    url: URL.comunityCommentDetail.replace('{id}', String(id)),
  });

  const row = plainToInstance(CommunityCommentDto, data.row);

  return row;
};
